// extracted by mini-css-extract-plugin
export default {"quote":"Quotes_quote__cPuZz","quotechild":"Quotes_quotechild__koccD"};